import React, { Component } from "react";
import {
  DKButton,
  DKIcons,
  DKLabel,
  DKIcon,
  DKCheckMark,
  DKLine,
  DKListPicker,
  showAlert,
  DKInput,
  DKSpinner,
  showLoader,
  TOAST_TYPE,
  showToast,
  removeLoader
} from "deskera-ui-library";
import ic_drag from "../../../assets/icons/ic_drag.png";
import Incrementor from "../../common/Incrementor";
import ApiManager from "../../../managers/ApiManager";
import FormFieldsEditor from "./FormFieldsEditor";
import AddSegmentPopup from "../../common/AddSegmentPopup";
import FormService from "../../../services/form";
import ContactService from "../../../services/contact";
import { PAGE_TYPE } from "../ComponentList";
import { shiftArrayElement } from "../../../utility/Utility";
import { DealManager } from "../../../managers/DealManager";
import { CONSTANTS, INPUT_TYPE } from "../../../constants/Constant";
import { TableManger, TABLES } from "../../../managers/TableManger";
import Table from "../../../services/table";

/*
PROPS
- data // this is current components data
- onDataChange
- className
- pageType (PAGE_TYPE)
*/

class FormEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
    let segmentData = ContactService.getSegments();
    let pipelineData = FormService.pipeLineData;
    let selectedSegmentData = FormService.getSelectedPipelineIndex(this.componentData.segmentId, this.componentData.pipelineId, segmentData)
    this.state = {
      needSegmentListPicker: false,
      needFormFieldsPopup: false,
      needAddSegmentPopup: false,
      segments: segmentData,
      selectedSegment: selectedSegmentData,
      pipelineData: pipelineData,
      totalSegments: [],
      totalSegmentValues : [],
      fieldDeleteInProgress: false
    };

    this.dragData = null;
  }

  render() {
    return (
      <div
        className={
          "column parent-width border-box mt-m border-radius-s p-r border-m shadow-s " +
          this.props.className
        }
      >
        {this.getSegmentSection()}
        {this.getPipelineSection()}
        {this.state.needAddSegmentPopup && this.getAddSegmentPopup()}
        <DKLine style={{ height: 3 }} className="mt-xl mb-s" />

        {/* /////////////////// */}
        <DKLabel text="Form fields" className="fw-m mt-l mb-s" />
        <div
          className="parent-width mt-r"
          onDragOver={this.handleDragOverParent}
          onDrop={this.handleDrop}
        >
          {this.getAllFields(this.componentData.value)}
        </div>
        {/* /////////////////// */}

        <div className="row-reverse mb-l mt-s">
          <DKButton
            className="bg-app text-white  ml-r"
            icon={DKIcons.white.ic_edit}
            onClick={this.showFormFieldsPopup}
            title="Edit"
            disabled={this.state.fieldDeleteInProgress}
          />
          <DKButton
            title="+ New field"
            onClick={this.showFormFieldsPopup}
            className="bg-gray1 border-m "
            disabled={this.state.fieldDeleteInProgress}
          />
          {this.state.fieldDeleteInProgress && (<div className="mr-s"><DKSpinner /></div>)}
        </div>
        <DKLine style={{ height: 3 }} className="mt-m mb-s" />
        {/*<div className="mt-xl row">*/}
        {/*  <Incrementor*/}
        {/*    title="Font"*/}
        {/*    value={this.componentData.style.labelSize}*/}
        {/*    onChange={(value) => {*/}
        {/*      this.changeStyle("labelSize", value);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*  <div>*/}
        {/*    <input*/}
        {/*      type="color"*/}
        {/*      className="ml-r"*/}
        {/*      value={this.componentData.style.labelColor}*/}
        {/*      onChange={(e) => this.changeStyle("labelColor", e.target.value)}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<Incrementor*/}
        {/*  className="mt-l"*/}
        {/*  title="Spacing"*/}
        {/*  value={this.componentData.style.fieldSpacing}*/}
        {/*  onChange={(value) => {*/}
        {/*    this.changeStyle("fieldSpacing", value);*/}
        {/*  }}*/}
        {/*/>*/}
        {/*<div className="mt-l row">*/}
        {/*  <Incrementor*/}
        {/*    title="Border"*/}
        {/*    value={this.componentData.style.fieldRadius}*/}
        {/*    onChange={(value) => {*/}
        {/*      this.changeStyle("fieldRadius", value);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*  <div>*/}
        {/*    <input*/}
        {/*      type="color"*/}
        {/*      className="ml-r"*/}
        {/*      value={this.componentData.style.fieldBorder}*/}
        {/*      onChange={(e) => this.changeStyle("fieldBorder", e.target.value)}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="row">*/}
        {/*  <DKLabel className="fw-b mt-m" text="Background"/>*/}
        {/*  <input*/}
        {/*    type="color"*/}
        {/*    className="ml-r mt-m"*/}
        {/*    value={this.componentData.style.fieldBackground}*/}
        {/*    onChange={(e) =>*/}
        {/*      this.changeStyle("fieldBackground", e.target.value)*/}
        {/*    }*/}
        {/*  />*/}
        {/*</div>*/}
        <div className="column mt-m parent-width">
          <DKLabel className="fw-b mb-s text-blue" text="Thank you Message" />
          <textarea
            rows={3}
            value={this.componentData.thankYouMsg || ""}
            name="message"
            className="parent-width border-box p-v-s p-h-s bg-gray1 border-blue border-none border-radius-s border-m app-font "
            style={{ minHeight: "5rem", outline: "none", resize: "none" }}
            onChange={(e) => {
              this.componentData.thankYouMsg = e.target.value;
              this.props.onDataChange(this.componentData);
            }}
          />
        </div>
        <div className="column mt-m parent-width">
          <DKLabel className="fw-b mb-s text-blue" text="Redirect URL" />
          <input
            className="parent-width border-box p-v-s p-h-s bg-gray1 border-blue border-none border-radius-s border-m "
            style={{ outline: "none" }}
            type="text"
            placeholder="https://www.example.com"
            value={
              this.props.pageType === PAGE_TYPE.FUNNEL
                ? "Goto-next-step"
                : this.componentData.redirectURL
            }
            onChange={(e) => {
              this.componentData.redirectURL = e.target.value;
              this.props.onDataChange(this.componentData);
            }}
            readOnly={this.props.pageType === PAGE_TYPE.FUNNEL}
          />
        </div>
        <DKLine style={{ height: 3 }} className="mt-xl mb-m" />
        <div className="column mt-m parent-width">
          <DKLabel className="fw-b mb-s" text="Button" />
          <input
            className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m "
            type="text"
            value={this.componentData.button.value}
            onChange={(e) => {
              let button = { ...this.componentData.button };
              button.value = e.target.value;
              this.componentData.button.value = e.target.value;
              this.props.onDataChange(this.componentData);
            }}
          />
        </div>
        <div className="mt-m row">
          <Incrementor
            title="Font"
            value={this.componentData.button.style.buttonSize}
            onChange={(value) => {
              this.changeButtonStyle("buttonSize", value);
            }}
          />
          <div>
            <input
              type="color"
              className="ml-r"
              value={this.componentData.button.style.buttonColor}
              onChange={(e) =>
                this.changeButtonStyle("buttonColor", e.target.value)
              }
            />
          </div>
        </div>
        <div className="row mb-l">
          <DKLabel className="fw-b mt-m" text="Button color" />
          <input
            type="color"
            className="ml-r mt-m"
            value={this.componentData.button.style.buttonBackground}
            onChange={(e) =>
              this.changeButtonStyle("buttonBackground", e.target.value)
            }
          />
        </div>
        {this.state.needFormFieldsPopup && this.getFormFieldsPopup()}
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getAddSegmentPopup() {
    return (
      <AddSegmentPopup
        onCancel={this.hideAddSegmentPopup}
        onSave={(columnData, segment, index) => {
          this.setSelectedSegmentData(segment, index);
          this.updateSegmentList(columnData.options || []);
        }}
      />
    );
  }

  showAddSegmentPopup = () => {
    this.setState({ needAddSegmentPopup: true });
  };

  hideAddSegmentPopup = () => {
    this.setState({ needAddSegmentPopup: false });
  };

  updateSegmentList = (data) => {
    this.setState({ needAddSegmentPopup: false, totalSegments: data });
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////

  getSegmentSection() {
    return (
      <div className="column parent-width mb-s">
        <DKLabel text="Job Opening and Job Pipelines" className="fw-m" />
        <DKLabel
          text="Select Job Opening and Job Pipelines below to capture this form data"
          className="text-gray mt-xs"
        />
        {/* <div className="row justify-content-between p-h-r p-v-s border-blue   border-radius-s mt-r position-relative cursor-hand">
          <div
            className="parent-height parent-width position-absolute"
            style={{ top: 0, left: 0 }}
            onClick={this.showSegmentListPicker}
          />
          <DKLabel
            className="fw-m unselectable text-blue"
            text={this.state.selectedSegment?.name}
          />
          <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s unselectable" />
          {this.state.needSegmentListPicker && this.getSegmentListPicker()}
        </div> */}
      </div>
    );
  }
  getPipelineSection() {
    return (
      <>
      {this.getTotalSegmentNames()}
      <DKInput
        className={"p-v-s segment-multi-select"}
        value={this.state.selectedSegment}
        options={this.state.totalSegments}
          type={INPUT_TYPE.MULTI_SELECT}
        onChange={(index) => {
          this.updateSelectedValues(index)
        }}
        direction="HORIZONTAL"
      />
      </>
    )
  }

  showSegmentListPicker = () => {
    if (this.state.needSegmentListPicker === false) {
      this.setState({ needSegmentListPicker: true });
    }
  };
  hideSegmentListPicker = () => {
    setTimeout(() => {
      this.setState({ needSegmentListPicker: false });
    }, 10);
  };
  setSelectedSegmentData = (data) => {
    this.componentData.segmentId = data.id;
    this.props.onDataChange(this.componentData);
    this.setState({ selectedSegment: data });
  };

  getSegmentListPicker() {
    return (
      <DKListPicker
        data={this.getSegmentNames()}
        className="position-absolute border-m shadow-m parent-width"
        style={{ top: 36, left: 0 }}
        onSelect={(index, value) => {
          this.setSelectedSegmentData(this.state.segments[index]);
          this.hideSegmentListPicker();
        }}
        button={{
          title: "+ Add Job Opening",
          className: "bg-app text-white",
          onClick: () => {
            this.showAddSegmentPopup();
          },
        }}
        onClose={this.hideSegmentListPicker}
      />
    );
  }

  getSegmentNames() {
    let segments = this.state.segments || [];
    return segments.map(function (item, index) {
      return item.name || "";
    });
  }

  getTotalSegmentNames() {
    let segments = this.state.segments || [];
    let pipelines = this.state.pipelineData || [];
    pipelines.forEach(element => {
      let isPresent = segments.some(x=> x.id === element.id);
      if (!isPresent) {
        segments.push(element);
      }
    });
    let processedData = this.prepareDataForSegments(segments);
    // let pipelines = this.prepareDataForSegments(this.state.pipelineData, CONSTANTS.PIPELINE);
    this.state.totalSegmentValues = processedData;
    this.state.totalSegments = this.state.totalSegmentValues.map(function (item, index) {
      return item.name || "";
    });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getAllFields(items) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getItemRow(item, index));
    });
    return arr;
  }

  getItemRow(item, index) {
    return (
      <div
        key={index}
        id={`form-field-${index}`}
        className="row mb-s pb-s editor-form-field"
        style={{
          transition: `transform 0.2s ease`,
        }}
        onDragOver={(event) => this.handleDragOver(event, index)}
      >
        <div className="column parent-width  ">
          <div className="row">
            <div
              draggable={true}
              onDragStart={(event) => this.handleDragStart(event, index)}
              onDragEnd={(event) => this.handleDragEnd(event, index)}
            >
              <DKIcon src={ic_drag} className="cursor-move mr-r ic-s-2" />
            </div>
            <div
              className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m cursor-hand"
              onClick={this.showFormFieldsPopup}
            >
              <DKLabel text={item.name + (item.required ? "*" : "")} />
            </div>
            <div
              className="row cursor-hand"
              style={{ width: "auto" }}
              onClick={() => {
                this.changeValue("required", !item.required, index);
              }}
            >
              <DKIcon src={item.icon} className="mr-s ic-s-2 unselectable" />
              <DKCheckMark className="ml-r" isSelected={item.required} />
            </div>
            <DKButton
              className=""
              icon={DKIcons.ic_delete}
              onClick={() => this.deleteField(index)}
              style={{ paddingRight: 0 }}
            />
          </div>
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  addFields = (selectedFields) => {
    this.componentData.value = [...selectedFields];
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////

  deleteField = (index) => {
    let selectedFieldData = this.componentData.value[index];
    if (selectedFieldData && selectedFieldData.required) {
      showAlert("Alert", "Mandatory fields cannot be deleted.");
      return;
    }
    const deleteConfirm = (selectedFieldData, index) => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
            
        },
        {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => this.deleteFieldsPermanently(selectedFieldData, index),
        },
    ];
    showAlert(
        "Delete field ?",
        "Deleting this field will delete it permanently. You can add new field anytime.",
        deleteConfirm(selectedFieldData, index)
      );
    
  };

  deleteFieldsPermanently = (selectedFieldData, index) => {
    this.setState({
      fieldDeleteInProgress: true
    });
    showLoader("Deleting... Please wait");
    let value = this.componentData.value;
    value.splice(index, 1);
    this.componentData.value = value;
    this.props.onDataChange(this.componentData);
    const tableId = TableManger.getTableId(TABLES.CANDIDATE)
    Table.deleteColumn(selectedFieldData.key, tableId).then((data) => {
      this.updateTableColumns(tableId);
    }, (err) => {
        this.setState({
          fieldDeleteInProgress: false
        });
        showToast("Something went wrong", TOAST_TYPE.FAILURE);
        removeLoader();
    });
  }

  updateTableColumns = (tableId) => {
    Table.getTable(tableId).then(
      (data) => {
        TableManger.setTableColumns(data, TABLES.CANDIDATE);
        this.setState({
          fieldDeleteInProgress: false
        });
        showToast("Field deleted successfully", TOAST_TYPE.SUCCESS);
        removeLoader();
      },
      (err) => {
        this.setState({
          fieldDeleteInProgress: false
        });
        showToast("Something went wrong", TOAST_TYPE.FAILURE);
        removeLoader();
       }
    );
  };
  

  //////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////     DRAG HANDLERS   ///////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  handleDragStart = (event, index) => {
    const formField = document.getElementById(`form-field-${index}`);
    event.dataTransfer.setDragImage(formField, 0, 0);
    event.dataTransfer.effectAllowed = "move";

    this.dragData = {};
    this.dragData.dragElement = formField;
    this.dragData.dragElementIndex = index;

    /* Stylings for Drag element & Siblings */
    setTimeout(() => {
      formField.style.opacity = 0;
    }, 0);
  };

  handleDragOverParent = (event) => {
    event.preventDefault();
  };

  handleDragOver = (event, index) => {
    event.preventDefault();

    event.dataTransfer.dropEffect = "move";
    if (this.dragData.dragOverIndex === index) return;

    this.dragData.dragOverIndex = index;
    this.handleDragOverAnimations();
  };

  handleDrop = (event) => {
    if (
      !this.dragData ||
      this.dragData.dragOverIndex === this.dragData.dragElementIndex
    )
      return;

    this.componentData.value = shiftArrayElement(
      this.componentData.value,
      this.dragData.dragElementIndex,
      this.dragData.dragOverIndex
    );
    this.props.onDataChange(this.componentData);
  };

  handleDragEnd = (event) => {
    /* cleanup and restyling */
    const formField = this.dragData.dragElement;
    const allFields = document.getElementsByClassName("editor-form-field");

    formField.style.opacity = 1;
    Array.from(allFields).forEach((field) => {
      field.style.transform = `none`;
    });

    this.dragData = null;
  };

  handleDragOverAnimations = () => {
    const { dragOverIndex, dragElementIndex, dragElement } = this.dragData;

    const allFields = document.getElementsByClassName("editor-form-field");
    Array.from(allFields).forEach((element, index) => {
      element.style.transform = `translateY(0)`;

      if (dragOverIndex === dragElementIndex) return;

      if (index > dragElementIndex && index <= dragOverIndex) {
        element.style.transform = `translateY(-${dragElement.clientHeight}px)`;
      } else if (index < dragElementIndex && index >= dragOverIndex) {
        element.style.transform = `translateY(${dragElement.clientHeight}px)`;
      }
    });
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  changeStyle = (property, value) => {
    let style = { ...this.componentData.style };
    style[property] = value;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  changeValue = (property, value, index) => {
    let new_value = this.componentData.value;
    new_value[index][property] = value;
    this.componentData.value = new_value;
    this.props.onDataChange(this.componentData);
  };

  changeButtonStyle = (property, value) => {
    let style = { ...this.componentData.button.style };
    style[property] = value;
    this.componentData.button.style = style;
    this.props.onDataChange(this.componentData);
  };
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  uploadImageToAWS(imageData, index) {
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.changeValue("icon", url, index);
      },
      (err) => {
        alert("Upload failed");
      }
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getFormFieldsPopup() {
    return (
      <FormFieldsEditor
        header="Add New Field"
        subHeader="Select any one field to add in the Form."
        data={this.getContactColumnsData()}
        onCancel={this.onFormFieldsPopupCancel}
        onSave={this.onFormFieldsPopupSave}
        selectedFields={this.componentData.value}
      />
    );
  }

  getContactColumnsData() {
    let contactColumnsData = FormService.getContactData(false);
    let componentDataValue = [...this.componentData.value];
    componentDataValue.forEach((item) => {
      let isDataFound = contactColumnsData.find(
        (contact) => contact.key === item.key
      );

      if (!isDataFound) {
        (contactColumnsData || []).push(item);
      } else {
        isDataFound.required =  item.required;
      }
    });
    return this.getAllFieldsWithSelectionStatus(contactColumnsData);
  }

  getAllFieldsWithSelectionStatus(contactColumnsData) {
    let componentDataValue = [...this.componentData.value];
    return contactColumnsData.map(function (item) {
      return {
        ...item,
        isSelected:
          (componentDataValue || []).filter((data) => data.key === item.key)
            .length > 0,
      };
    });
  }

  //////////////////////////////////////////////////////

  showFormFieldsPopup = () => {
    this.setState({
      needFormFieldsPopup: true,
    });
  };

  hideFormFieldsPopup = () => {
    this.setState({
      needFormFieldsPopup: false,
    });
  };

  //////////////////////////////////////////////////////

  onFormFieldsPopupSave = (allFieldsData) => {
    this.addFields(allFieldsData);
    this.hideFormFieldsPopup();
  };

  onFormFieldsPopupCancel = () => {
    this.hideFormFieldsPopup();
  };

  prepareDataForSegments(data) {
    data.forEach(element => {
      // if (element && element.type != "") {
        switch (element.type) {
          // case CONSTANTS.SEGMENT:
          //   element["type"] = module;
          //   break;
          case CONSTANTS.PIPELINE:
            if (element.name === CONSTANTS.DEFAULT_JOB_PIPELINE) {
              element.name = CONSTANTS.DEFAULT_PIPELINE
            }
            // element["type"] = module;
            break;
          default:
            if (typeof element.id === "number") {
              element["type"] = CONSTANTS.SEGMENT;
            }
        }
      // }
    });
    return data;
  }

  updateSelectedValues(indexArray) {
    let selectedSegmentArray = [];
    this.setState({
      selectedSegment : indexArray
    })
    indexArray.map((index) => {
      if(this.state.totalSegmentValues[index]) {
        selectedSegmentArray.push(this.state.totalSegmentValues[index])
      }
    });
    this.componentData.selectedSegmentData = selectedSegmentArray;
    let segmentData = selectedSegmentArray.filter(x => x.type === CONSTANTS.SEGMENT);
    let pipelineData = selectedSegmentArray.filter(x => x.type === CONSTANTS.PIPELINE);
    this.componentData.segmentId = segmentData.map((value) => {
      return value.id;
    });
    this.componentData.pipelineId = pipelineData.map((value) => {
      return value.id;
    });
    this.props.onDataChange(this.componentData);
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export default FormEditor;
